import {RaEvent, RaEventType} from "./RaEvent";
import {IUserModelDelta, IUserModel} from "../services/usermodel/usermodel.objects";

export class UserModelUpdateRequestEvent extends RaEvent {
    static TYPE:RaEventType = "user_model_update_request_event";
    constructor() {
        super(UserModelUpdateRequestEvent.TYPE);
    }
}

export class UserModelUpdateReceivedEvent extends RaEvent {
    static TYPE:RaEventType = "user_model_update_received_event";
    constructor(private _userModel:IUserModel) {
        super(UserModelUpdateReceivedEvent.TYPE);
    }

    public get userModel():IUserModel {
        return this._userModel;
    }
}

export class UserModelInitializedEvent extends RaEvent {
    static TYPE: RaEventType = "user_model_initialized_event";
    constructor(private _delta: IUserModelDelta) {
        super(UserModelInitializedEvent.TYPE);
    }

    public get delta(): IUserModelDelta {
        return this._delta;
    }
}

export class UserModelChangedEvent extends RaEvent {
    static TYPE:RaEventType = "user_model_changed_event";
    constructor(private _delta:IUserModelDelta) {
        super(UserModelChangedEvent.TYPE);
    }

    public get delta():IUserModelDelta {
        return this._delta;
    }
}
